module.exports = __webpack_public_path__ + "static/img/wooden-pallets.3b02cbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/package-service/wooden-pallets.png
// module id = SQff
// module chunks = 2